import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Consultar dados brutos',
      'SUBTITULO': 'Consulte as informações dos Dados Brutos das pesquisas geradas na plataforma em um período específico',
      'NOFILE': 'não gerado',
      'FILTER': 'Filtrar por empresa',
      'DOWNLOADFILE': '⇬ Fazer download do arquivo',
      'CAMPOS': {
        'anio': 'Ano',
        'broker': 'Corretor',
        'brokerCountry': 'País do corretor',
        'anioRanking': 'Classificação do ano',
      },
      'COLUMNAS': {
        'nombre': 'Companhia',
        'producto': 'Tipo de Produto',
        'surveytoken': 'Token de pesquisa',
        'fecha': 'Encontro',
        'acciones': 'Dados não tratados',
      },
      'RESULTADOS': {
        'CARGANDO': 'Carregando resultados de pesquisa',
        'TITULO': 'Resultados',
        'ENCONTRADAS': 'Total de pesquisas encontradas',
        'DESCARGAR': 'Baixar informações em formato Excel',
        'SINRESULTADOS': 'Nenhuma pesquisa criada com os parâmetros especificados foi encontrada'
      }
    }
  }
};
